export enum MediaType {
    VIDEO = 'VIDEO',
    PHOTO = 'PHOTO',
    ANIMATION = 'ANIMATION',
    AUDIO = 'AUDIO',
}
